module.exports = __webpack_public_path__ + "img/logo_weshope_header.c4cea073.png";